import { cloneDeep } from 'lodash';

const cancelOrder = (state, payload) => {
  const newState = cloneDeep(state);
  delete newState.activeEvents[payload.orderId]
  return newState;
};

export { cancelOrder };
